module.exports = __webpack_public_path__ + "static/31-PER-PISCO.8c28c87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/31-PER-PISCO.png
// module id = 630
// module chunks = 35783957827783